'use strict';

const light = {
    list: {
        paddingTop: 4,
        paddingBottom: 4,
    },
    paper: {
        marginTop: 4,
        marginBottom: 4,
    },
};

var MuiMenu = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiMenu = MuiMenu;
exports.light = light;
